import { IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import CircularProgressLoading from '../../../components/Accessibility/CircularProgressLoading';
import DefaultButton from '../../../components/Accessibility/DefaultButton';
import DefaultPagination from '../../../components/Accessibility/DefaultPagination';
import DefaultTable from '../../../components/Accessibility/DefaultTable';
import TableRegular from '../../../components/Accessibility/DefaultTable/TableRegular';
import DefaultText from '../../../components/Accessibility/DefaultText';
import DefaultTextBold from '../../../components/Accessibility/DefaultTextBold';
import PageTitle from '../../../components/Accessibility/PageTitle';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { Procedimento } from '../../../interfaces/entities/ClassificacaoProcedimentos/Procedimento';
import { getListaProcs } from '../../../services/ContratoService';
import { useMediaQuery } from "@mui/material";
import './styles.css';
import { sxInput } from './sxProps';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';

const ClassificacaoProcedimentos: React.FC = () => {

  const { textStyleAccessibility } = useAccessibility();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const [procedimentos, setProcedimentos] = useState<Procedimento[]>([]);
  const [consulta, setConsulta] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);
  const [showModal, setShowModal] = useState<boolean>(false);
  const pageSize = 17;

  const searchByString = (value: string) => {
    setLoading(true);
    getListaProcs(value)
      .then(response => {
        setPage(1);
        setProcedimentos(response);
      })
      .catch(error => {
        setShowModal(true);
      })
      .finally(() => {
        setLoading(false);
      })
  }

  const paginatedProcedimentos = procedimentos.slice(
    (page - 1) * pageSize, 
    page * pageSize
  )

  const handlePageChange = async (page: number) => {
    setPage(page)
  }

  useEffect(() => {
    searchByString("")
  }, [])

  const handleConsultarClicked = () => {
    searchByString(consulta)
  }

  const handleConsultarClear = () => {
    setConsulta('')
    searchByString('')
  }

  return (
    <div className='page'>

      <PageTitle text="Classificação de Procedimentos para Coparticipação" />
      <DefaultText text="Consulte aqui os procedimentos e veja a classificação correspondente para a cobrança de coparticipação" />

      <div style={{ marginTop: '10px' }}>
        <DefaultTextBold text="Pesquise procedimentos" />
        <label htmlFor='descricaoInput' aria-label='Pesquise procedimentos' />
      </div>

      <div className="search-container">
        <OutlinedInput
          id="descricaoInput"
          type={'text'}
          value={consulta}
          placeholder='Exemplo: 101010 (código) ou Consulta (descrição)'
          onChange={(e) => {
            const value = e.target.value;
            setConsulta(value.toUpperCase());
          }}
          style={textStyleAccessibility}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleConsultarClicked();
            }
          }}
          name='pesquisa'
          maxRows={1}
          sx={sxInput}
          endAdornment={
            consulta && (
              <InputAdornment position='end'>
                <IconButton onClick={handleConsultarClear} edge="start" aria-label="limpar pesquisa">
                  <FontAwesomeIcon icon={faTimes} size='2xs' />
                </IconButton>
              </InputAdornment>
            )
          }
        />
        <DefaultButton text='Consultar' onClick={handleConsultarClicked} />
      </div>

      {
        loading ? <CircularProgressLoading /> :
          !procedimentos.length ? <DefaultText text="Nenhum resultado foi encontrado para a sua busca" /> :
            <DefaultTable
              data={paginatedProcedimentos.map(item => ([
                <TableRegular key={`${item.tipoCobertura}-${item.classificacao}`} text={item.tipoCobertura} />,
                <TableRegular key={`${item.classificacao}-${item.descricao}`} text={item.classificacao} />,
                <TableRegular key={`${item.descricao}-${item.tipoCobertura}`} text={item.descricao} />,
              ]))}
              headers={["Tipo de cobertura", "Classificação", "Descrição"]}
              columnWidths={isMobile ? ["33%", "33%", "34%"] : ["20%", "20%", "60%"]}
            />
      }

      {
        !loading && procedimentos.length > pageSize &&
          <div style={{ marginTop: '5px' }}>
            <DefaultPagination
              currentPage={page}
              totalPages={Math.ceil(procedimentos.length / pageSize)}
              handlePageChange={handlePageChange}
            />
          </div>
      }

      <ModalFeedBack
				showModal={showModal} 
				handleShowModal={() => setShowModal(false)}
				icon={'error'}
				textButton={''} 
				title={'Erro ao buscar dados'}
				subTitle={'Ocorreu um erro ao buscar os dados. Tente novamente mais tarde.'}
			/>
      
    </div>
  )
}

export default ClassificacaoProcedimentos;